import PropTypes from 'prop-types';
import React from 'react';
import Immutable from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';

import { SecondaryLink } from '@bibliocommons/base-links';

import { ExpandableList } from 'app/components/shared/Expandable';
import AuthorLink from 'app/components/bibs/shared/AuthorLink';

import { authorSuggestionShape, relatedAuthorShape } from 'app/shapes/bibPage';
import './AuthorsList.scss';

function renderAuthorLink(author, handleClick) {
  return <AuthorLink linkTag={SecondaryLink} authors={Immutable.List.of(author)} handleClick={handleClick} />;
}

export default function AuthorsList({ authors, handleClick }) {
  return (
    <div className="cp-authors-list">
      <ExpandableList
        className="authors-list"
        collapseCount={3}
        expandLinkHref="#show-more-authors"
        getItemKey={author => author}
        itemClassName="author-item"
        list={authors}
        renderItem={author => renderAuthorLink(author, handleClick)}
        stacked
        textKey="authors"
      />
    </div>
  );
}

AuthorsList.propTypes = {
  authors: ImmutablePropTypes.listOf(PropTypes.oneOfType([authorSuggestionShape, relatedAuthorShape])).isRequired,
  handleClick: PropTypes.func.isRequired
};
